import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

export const fetchLiveSessionJoinUrl = async (sessionId, authenticatedUser) => {
  const url = `${getConfig().LMS_BASE_URL}/blendxapi/live-sessions/${sessionId}/join-url/`;
  const fullName = authenticatedUser?.name || authenticatedUser?.username || 'Learner';

  const response = await getAuthenticatedHttpClient().post(url, {
    role: 'VIEWER',
    fullName,
  });

  return response.data?.url || null;
};
